import { render, staticRenderFns } from "./TreeNodeDocumentDelivery.vue?vue&type=template&id=d354ecda&"
import script from "./TreeNodeDocumentDelivery.vue?vue&type=script&lang=js&"
export * from "./TreeNodeDocumentDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports